import { Box } from "@mui/material"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/system"
import MeetingReviewCard from "components/meetings/MeetingReviewCard"
import ScheduleMeetingDialogCloseIconButton from "components/meetings/ScheduleMeetingDialog/ScheduleMeetingDialogCloseIconButton"
import ScheduleMeetingDialogContainer from "components/meetings/ScheduleMeetingDialog/ScheduleMeetingDialogContainer"
import ScheduleMeetingDialogContent from "components/meetings/ScheduleMeetingDialog/ScheduleMeetingDialogContent"
import ScheduleMeetingDialogGoBackButton from "components/meetings/ScheduleMeetingDialog/ScheduleMeetingDialogGoBackButton"
import ScheduleMeetingDialogHeader from "components/meetings/ScheduleMeetingDialog/ScheduleMeetingDialogHeader"
import ScheduleMeetingDialogSingleBottomButton from "components/meetings/ScheduleMeetingDialog/ScheduleMeetingDialogSingleBottomButton"
import ConventionAvailableMeetingTime from "models/convention-api/v1/ConventionAvailableMeetingTime"
import ConventionMeetingType from "models/convention-api/v1/ConventionMeetingType"
import React from "react"

interface ScheduleMeetingDialogConfirmDateProps {
  onGoBack: () => void
  onClose: () => void
  onBookMeeting: () => void
  selectedMeetingTime: ConventionAvailableMeetingTime
  selectedMeetingType: ConventionMeetingType
  isLoading: boolean
}

const ScheduleMeetingDialogConfirmDate = (props: ScheduleMeetingDialogConfirmDateProps) => {
  const { onClose, onGoBack, onBookMeeting, selectedMeetingType, selectedMeetingTime, isLoading } =
    props
  return (
    <_Container>
      <ScheduleMeetingDialogHeader>
        <ScheduleMeetingDialogGoBackButton
          ariaLabel="Go back to selecting date"
          onClick={onGoBack}
        />
        <ScheduleMeetingDialogCloseIconButton onClick={onClose} />
      </ScheduleMeetingDialogHeader>
      <ScheduleMeetingDialogContainer isLoading={isLoading}>
        <ScheduleMeetingDialogContent sx={{ marginBottom: "50px" }}>
          <_AccentText component="h3">Review your meeting details</_AccentText>
          <MeetingReviewCard meetingTime={selectedMeetingTime} meetingType={selectedMeetingType} />
        </ScheduleMeetingDialogContent>
        <ScheduleMeetingDialogSingleBottomButton label="BOOK MEETING" onClick={onBookMeeting} />
      </ScheduleMeetingDialogContainer>
    </_Container>
  )
}

export default ScheduleMeetingDialogConfirmDate

const _AccentText = styled(Typography)(({ theme }) => ({
  marginTop: "8px",
  marginBottom: "30px",

  ...theme.fonts.lato400,
  fontSize: 20,
  lineHeight: 1.2,
})) as typeof Typography

const _Container = styled(Box)({
  display: "flex",
  flexDirection: "column",

  minHeight: "360px",
  height: "100%",
})
